export default [
  {
    path: '/halal-other-forms',
    name: 'halal-other-forms',
    component: () => import('@/views/halal/other-forms/OtherForms.vue'),
    meta: {
      title: 'Other Forms Halal',
      requiresAuth: true,
      action: 'browes',
      resource: 'Other Forms Halal',
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Other Forms Halal',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/halal-other-forms/edit/:id',
    name: 'edit-halal-other-forms',
    component: () => import('@/views/halal/other-forms/control-other-forms/EditOtherForms.vue'),
    meta: {
      title: 'Edit Other Forms Halal',
      requiresAuth: true,
      pageTitle: 'Other Forms Halal',
      breadcrumb: [
        {
          text: 'Other Forms Halal',
          to: '/halal-other-forms',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
